import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efbc35d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire-fill-out-step" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label-birthday" }, "生年月日 [必須]", -1))
const _hoisted_4 = { class: "input-tiny-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "side-label" }, "年", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "side-label" }, "月", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "side-label no-padding-right" }, "日", -1))
const _hoisted_8 = { class: "input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "性別 [必須]", -1))
const _hoisted_10 = { class: "input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "お客様の体調ついてお尋ねいたします [必須]", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about-checkbox" }, [
  /*#__PURE__*/_createTextVNode(" 1）風邪症状（発熱：37.2度以上、のどの痛み、頭痛、関節痛 など）、呼吸器症状（息苦しさ、息の吸いづらさ、咳など）、その他の症状（下痢、結膜炎症状、味が薄く感じる、味覚障害など）など、上記に当てはまる体調不良はありません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2）2週間以内に入国制限、入国後の観察期間を必要とされている国・地域への渡航や、該当国の在住者との濃厚接触はありません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3）1週間以内に同居者他の体調不良はありません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4）会場（ホール玄関・ロビー含む）内では、マスクの着用をお願いしております。 ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "checkbox-label" }, "上記、全て確認しました", -1))
const _hoisted_14 = { class: "input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "個人情報に関して [必須]", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about-checkbox" }, " 新型コロナウイルス感染症対策として、自治体関係機関（保健所等）から開示要請があった場合に、ご入力いただいた個人情報を提供をさせていただく可能性がございます。 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "checkbox-label" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.app.c-rayon.com/policy",
    target: "_blank"
  }, "プライバシーポリシー"),
  /*#__PURE__*/_createTextVNode("に同意します ")
], -1))
const _hoisted_18 = { class: "container-buttons" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 確認画面へ ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 閉じる ")
const _hoisted_21 = { ref: "focus" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInputText = _resolveComponent("AppInputText")!
  const _component_AppInputDropdown = _resolveComponent("AppInputDropdown")!
  const _component_QuestionnaireFillOutGenderInput = _resolveComponent("QuestionnaireFillOutGenderInput")!
  const _component_AppInputCheckbox = _resolveComponent("AppInputCheckbox")!
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!
  const _component_AppButtonSecondary = _resolveComponent("AppButtonSecondary")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _cache[13] || (_cache[13] = () => {})
      }, {
        default: _withCtx(({ meta, errors, setTouched, validate, validateField }) => [
          _createVNode(_component_AppInputText, {
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            class: "input",
            name: "name",
            type: "text",
            rules: "required",
            label: "お名前 [必須]",
            placeholder: "平井 太郎",
            "display-error": 
            !meta.valid &&
            meta.touched &&
            _ctx.touched.name &&
            errors['name'] !== undefined
          ,
            onTouched: _cache[1] || (_cache[1] = 
            () => {
              _ctx.touched = { ..._ctx.touched, name: true }
            }
          )
          }, null, 8, ["modelValue", "display-error"]),
          _createVNode(_component_AppInputText, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
            class: "input",
            name: "email",
            type: "email",
            rules: "required|email",
            label: "メールアドレス [必須]",
            placeholder: "hirai@abc.com",
            "display-error": 
            !meta.valid &&
            meta.touched &&
            _ctx.touched.email &&
            errors['email'] !== undefined
          ,
            "error-message": '正しいメールアドレス形式で入力ください',
            onTouched: _cache[3] || (_cache[3] = 
            () => {
              _ctx.touched = { ..._ctx.touched, email: true }
            }
          )
          }, null, 8, ["modelValue", "display-error"]),
          _createVNode(_component_AppInputText, {
            modelValue: _ctx.phoneNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneNumber) = $event)),
            class: "input",
            name: "phoneNumber",
            type: "tel",
            rules: "required|phoneNumber",
            label: "電話番号 [必須]",
            placeholder: "090-1234-5678",
            "display-error": 
            !meta.valid &&
            meta.touched &&
            _ctx.touched.phoneNumber &&
            errors['phoneNumber'] !== undefined
          ,
            "error-message": '正しい電話番号を入力ください',
            onTouched: _cache[5] || (_cache[5] = 
            () => {
              _ctx.touched = { ..._ctx.touched, phoneNumber: true }
            }
          )
          }, null, 8, ["modelValue", "display-error"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AppInputText, {
              modelValue: _ctx.year,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.year) = $event)),
              name: "year",
              type: "tel",
              rules: { required: true, year: true },
              "display-error": 
              !meta.valid &&
              meta.touched &&
              _ctx.touched.year &&
              errors['year'] !== undefined
            ,
              placeholder: "1991",
              size: "small",
              onTouched: 
              () => {
                _ctx.touched = { ..._ctx.touched, year: true }
                validateField('date')
              }
            
            }, null, 8, ["modelValue", "display-error", "onTouched"]),
            _hoisted_5,
            _createVNode(_component_AppInputText, {
              modelValue: _ctx.month,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.month) = $event)),
              name: "month",
              type: "tel",
              rules: { required: true, month: true },
              "display-error": 
              !meta.valid &&
              meta.touched &&
              _ctx.touched.month &&
              errors['month'] !== undefined
            ,
              placeholder: "01",
              size: "tiny",
              onTouched: 
              () => {
                _ctx.touched = { ..._ctx.touched, month: true }
                validateField('date')
              }
            
            }, null, 8, ["modelValue", "display-error", "onTouched"]),
            _hoisted_6,
            _createVNode(_component_AppInputText, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.date) = $event)),
              name: "date",
              type: "tel",
              rules: { required: true, date: true },
              "display-error": 
              !meta.valid &&
              meta.touched &&
              _ctx.touched.date &&
              errors['date'] !== undefined
            ,
              placeholder: "01",
              size: "tiny",
              onTouched: _cache[9] || (_cache[9] = 
              () => {
                _ctx.touched = { ..._ctx.touched, date: true }
              }
            )
            }, null, 8, ["modelValue", "display-error"]),
            _hoisted_7
          ]),
          _createVNode(_component_AppInputDropdown, {
            modelValue: _ctx.prefecture,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.prefecture) = $event)),
            class: "input",
            name: "prefecture",
            options: _ctx.prefectureOptions,
            rules: "required",
            label: "都道府県 [必須]",
            placeholder: "都道府県",
            "display-error": _ctx.touched.prefecture && !_ctx.isPrefectureValid
          }, null, 8, ["modelValue", "options", "display-error"]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_QuestionnaireFillOutGenderInput, {
              gender: _ctx.gender,
              "display-error": _ctx.touched.gender && !_ctx.isGenderValid,
              onCheck: _cache[11] || (_cache[11] = 
              (value) => {
                _ctx.toggleGender(value);
              }
            )
            }, null, 8, ["gender", "display-error"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createVNode(_component_AppInputCheckbox, {
              checked: _ctx.confirmsIsInGoodHealth,
              "display-error": 
              _ctx.touched.confirmsIsInGoodHealth && !_ctx.confirmsIsInGoodHealth
            ,
              onCheck: _ctx.toggleConfirmsIsInGoodHealth
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["checked", "display-error", "onCheck"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createVNode(_component_AppInputCheckbox, {
              checked: _ctx.agreesToPrivatePolicy,
              "display-error": 
              _ctx.touched.agreesToPrivatePolicy && !_ctx.agreesToPrivatePolicy
            ,
              onCheck: _ctx.toggleAgreesToPrivatePolicy
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["checked", "display-error", "onCheck"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_AppButtonPrimary, {
              active: _ctx.canSave(meta.valid),
              onButton: ($event: any) => (_ctx.proceed(meta.valid, setTouched, validate))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 2
            }, 1032, ["active", "onButton"]),
            _createVNode(_component_AppButtonSecondary, {
              onButton: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('previous')))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, null, 512)
        ]),
        _: 1
      })
    ])
  ]))
}